module.exports = __webpack_public_path__ + "static/SO_Album_Square-12387b3beffa7292c78c38a9096b8477.png";